export default __webpack_public_path__ + "static/media/cold-drink.82653916.webp";